import { Facebook, Mail, MessageSquare, Phone } from "lucide-react";
import { telHref, useSite } from "../context/SiteContext";
import { TikTokIcon } from "../components/site/Decor";

const cards = (c) => [
  { id: "phone", icon: Phone, label: "Call us", value: c.phone, href: telHref(c.phone) },
  { id: "text", icon: MessageSquare, label: "Text us", value: c.phone, href: telHref(c.phone, "sms") },
  { id: "email", icon: Mail, label: "Email", value: c.email, href: `mailto:${c.email}` },
  c.facebook && { id: "facebook", icon: Facebook, label: "Facebook", value: "KMK Customs Embroidery", href: c.facebook, ext: true },
  c.tiktok && { id: "tiktok", icon: TikTokIcon, label: "TikTok", value: c.tiktok_handle || "TikTok", href: c.tiktok, ext: true },
].filter(Boolean);

export const ContactCards = () => {
  const { contact } = useSite().site;
  const CARDS = cards(contact);
  return (
      <section id="contact" className="mx-auto grid max-w-7xl scroll-mt-28 gap-5 px-6 py-16 sm:grid-cols-2 lg:grid-cols-3" data-testid="contact-section">
        {CARDS.map(({ id, icon: Icon, label, value, href, ext }) => (
          <a key={id} href={href} target={ext ? "_blank" : undefined} rel={ext ? "noreferrer" : undefined} data-testid={`contact-${id}`}
            className="group flex items-center gap-5 rounded-3xl bg-[#FFF4F8] p-6 transition-transform duration-200 hover:-translate-y-1">
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-[#0E0B0D] text-[#D4A537] transition-colors duration-200 group-hover:bg-[#FF1F8E] group-hover:text-white">
              <Icon className="h-6 w-6" />
            </span>
            <span className="min-w-0">
              <span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#D4A537]">{label}</span>
              <span className="block break-all font-display text-lg font-bold">{value}</span>
            </span>
          </a>
        ))}
      </section>
  );
};
